<template>
  <div
    v-if="visible"
    v-click-outside="handleClickOutside"
    :class="{
      'w-full': fullWidth,
      'top-full left-0': !right,
      'top-full right-0': right,
    }"
    class="
      absolute bg-base-0 z-10
      mt-4 border-0.5 border-base-30 rounded-md
      shadow-dropdown
    "
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClickOutside() {
      this.$emit('hide')
    },
  },
}
</script>
